// extracted by mini-css-extract-plugin
export default {"tabContainer":"MenuTabs_tabContainer__cGRgB","tab":"MenuTabs_tab__P3QN8","active":"MenuTabs_active__5takV","disabled":"MenuTabs_disabled__OZC0-"};